import * as types from "../store/dadosCadastrais.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  NomeCadastral: undefined,
  NomeFantasiaCadastral: undefined,
  EmailCadastral: undefined,
  TelefoneCadastral: undefined,
  CelularCadastral: undefined,
  DataNascimentoCadastral: undefined,
  RgIeCadastral: undefined,
  DataAberturaCadastral: undefined,
  DataAberturaEmpresa: undefined,
  Contador: undefined,
  EmailContadorCadastral: undefined,
  RegimeTributacaoCadastral: undefined,
  RegimeTributacaoErrada: undefined,
  RegimeTributacaoSolicitacaoDescricao: undefined,
  DataOcorrencia: undefined,
  IdGrupo: undefined,
  changeState: undefined,
  openModalContador: false,
  ContadorContribuinte: {
    Id: undefined,
    CgcCpf: undefined,
    Nome: undefined,
    Email: undefined,
    Telefone: undefined,
    RgInscricaoEstadual: undefined,
    Endereco: {},
    Numero: undefined,
    Complemento: undefined,
    disabledForm: true,
  },
});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload === undefined ? {} : action.payload;
  switch (action.type) {
    case types.DADOSCADASTRAIS_SET:
      return state.merge(payload);
    case types.SET_CONTADOR_CONTRIBUINTE:
      return state.merge({
        ContadorContribuinte: state.ContadorContribuinte.merge(payload),
      });
    case types.DADOSCADASTRAIS_RESETFORM:
      return state.merge({ initialState, changeState: new Date().getTime() });
    case types.OPEN_MODAL_CONTADOR:
      return state.merge({ openModalContador: action.payload });
    case types.RESET_CONTADOR_CONTRIBUINTE:
      return state.merge({
        ContadorContribuinte: initialState.ContadorContribuinte,
      });
    case types.RESET_DATA_ABERTURA_CADASTRAL:
      return state.merge({ DataAberturaCadastral: null });
    case types.RESET_DATA_OCORRENCIA:
      return state.merge({ DataOcorrencia: null });
    case commonActionType.RESET:
      return initialState;
    default:
      return state;
  }
};

store.registerDynamicModule("dadosCadastrais", reduce);
